"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { height, width } = param;
    return {
        aspectRatio: width / height,
        display: 'flex',
        maxWidth: width,
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
        img: {
            aspectRatio: width / height,
            left: 0,
            objectFit: 'cover',
            objectPosition: '50% 50%',
            position: 'absolute',
            top: 0,
            width: '100%'
        }
    };
});
